module.exports = __webpack_public_path__ + "static/img/30019 (4).5bd7365.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30019 (4).webp
// module id = 5fkt
// module chunks = 14